<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
      <h4 style="text-indent: 30pt;">
        {{ "module-assignment.giftCard.mixedGiftCard" | translate }}
      </h4>
      <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
        <mat-slide-toggle
          id="matSelectToggleTMMixedGiftCard"
          formControlName="mixedGiftCard"
          (change)="toggleTMMixedGiftCard()"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div *ngIf="enableTmMixedGiftCardDetails">
      <mat-card-content style=" padding-left: 40px;">
        <div fxLayout="row wrap" fxLayoutGap="20px grid">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style="padding-right: 20pt;">
              {{"module-assignment.giftCard.provider" | translate }}
              <span class="required-astrik" *ngIf="isRequired('mixedGiftCardProvider')">*</span>
            </mat-label>
            <mat-form-field id="matFrmFieldProvider">
              <mat-select
                [required]="isRequired('mixedGiftCardProvider')"
                (selectionChange)="changeTmMixedGCProvider()"
                [placeholder]="'module-assignment.giftCard.please_select' | translate "
                formControlName="mixedGiftCardProvider"
                id="matSelectTMMixedGiftCardProvider"
              >
                <mat-option value="Netsuite">Netsuite</mat-option>
                <mat-option value="GiveX">GiveX</mat-option>
                <mat-option value="SVS">SVS</mat-option>
                <mat-option value="Paraspar">Paraspar</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="enableTmProviderNetsuiteDetails">
          <netsuite-gift-card-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [netsuiteConfigurationDetails]="tmGiftCardNetsuiteAuthDetails"
            [authControlKey]="'tmGiftCardNetsuiteConfiguration'"
          ></netsuite-gift-card-configuration>
        </div>
        <div *ngIf="enableTmProviderGivexDetails">
          <givex-gift-card-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [givexConfigurationDetails]="tmGiftCardGivexAuthDetails"
            [authControlKey]="'tmGiftCardGivexConfiguration'"
          ></givex-gift-card-configuration>
        </div>
        <div *ngIf="enableTmGiftCardCommonDetails">
          <gift-card-common-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [giftCardConfigurationDetails]="tmGiftCardCommonConfigDetails"
            [authControlKey]="this.tmGiftCardCommonAuthControlKey"
            [provider]="getTMMixedGiftCardProvider()"
          ></gift-card-common-configuration>
        </div>
      </mat-card-content>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
      <h4 style="text-indent: 30pt;">
        {{ "module-assignment.giftCard.physicalGiftCard" | translate }}
      </h4>
      <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
        <mat-slide-toggle
          id="matSelectToggleTMPhysicalGiftCard"
          formControlName="physicalGiftCard"
          (change)="toggleTMPhysicalGiftCard()"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div *ngIf="enableTmPhysicalGiftCardDetails">
      <mat-card-content style=" padding-left: 40px;">
        <div fxLayout="row wrap" fxLayoutGap="20px grid">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style="padding-right: 20pt;">
              {{"module-assignment.giftCard.provider" | translate }}
              <span class="required-astrik" *ngIf="isRequired('physicalGiftCardProvider')">*</span>
            </mat-label>
            <mat-form-field id="matFrmFieldProvider">
              <mat-select
                [required]="isRequired('physicalGiftCardProvider')"
                (selectionChange)="changeTmPGCProvider()"
                [placeholder]="'module-assignment.giftCard.please_select' | translate "
                formControlName="physicalGiftCardProvider"
                id="matSelectTMPhysicalGiftCardProvider"
              >
                <mat-option value="Netsuite">Netsuite</mat-option>
                <mat-option value="GiveX">GiveX</mat-option>
                <mat-option value="SVS">SVS</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="enableTmProviderPGCNetsuiteDetails">
          <netsuite-gift-card-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [netsuiteConfigurationDetails]="tmPGCNetsuiteAuthDetails"
            [authControlKey]="'tmPGCNetsuiteConfiguration'"
          ></netsuite-gift-card-configuration>
        </div>
        <div *ngIf="enableTmProviderPGCGivexDetails">
          <givex-gift-card-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [givexConfigurationDetails]="tmPGCGivexAuthDetails"
            [authControlKey]="'tmPGCGivexConfiguration'"
          ></givex-gift-card-configuration>
        </div>
        <div *ngIf="enableTmPGCCommonDetails">
          <gift-card-common-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [giftCardConfigurationDetails]="tmPGCCommonConfigDetails"
            [authControlKey]="this.tmPGCCommonAuthControlKey"
            [provider]="getTMPGCProvider()"
          ></gift-card-common-configuration>
        </div>
      </mat-card-content>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
      <h4 style="text-indent: 30pt;">
        {{ "module-assignment.giftCard.eGiftCard" | translate }}
      </h4>
      <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
        <mat-slide-toggle
          id="matSelectToggleTMEGiftCard"
          formControlName="eGiftCard"
          (change)="toggleTMEGiftCard()"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div *ngIf="enableTmEGiftCardDetails">
      <mat-card-content style=" padding-left: 40px;">
        <div fxLayout="row wrap" fxLayoutGap="20px grid">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style="padding-right: 20pt;">
              {{"module-assignment.giftCard.provider" | translate }}
              <span class="required-astrik" *ngIf="isRequired('eGiftCardProvider')">*</span>
            </mat-label>
            <mat-form-field id="matFrmFieldProvider">
              <mat-select
                [required]="isRequired('eGiftCardProvider')"
                [placeholder]="'module-assignment.giftCard.please_select' | translate "
                (selectionChange)="changeTmEGCProvider()"
                formControlName="eGiftCardProvider"
                id="matSelectTMEGiftCardProvider"
              >
                <mat-option value="Paraspar">Paraspar</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="enableTmEGCCommonDetails">
          <gift-card-common-configuration
            [action]="action"
            [parentForm]="parentForm.get(authControlKey)"
            [giftCardConfigurationDetails]="tmEGCCommonConfigDetails"
            [authControlKey]="this.tmEGCCommonAuthControlKey"
            [provider]="getTMEGCProvider()"
          ></gift-card-common-configuration>
        </div>
      </mat-card-content>
    </div>
  </div>
</div>
